import styled from 'styled-components';
typeof window !== 'undefined' &&
    !window.__DS_WEB_VERSION__ &&
    (window.__DS_WEB_VERSION__ = '2.4.0');
import { withFlex, withMargins, withPaddings } from '../../mixins';
/**
 * Componente utilitário Flex.
 *
 * Facilita a aplicação de containers flex na aplicação.
 */
export const Flex = styled.div.attrs(({ 'data-ds-component': customDataDsComponent }) => ({
    'data-ds-component': customDataDsComponent !== null && customDataDsComponent !== void 0 ? customDataDsComponent : 'DS-Flex',
})) `
  ${withFlex}
  ${withMargins}
  ${withPaddings}
`;
